/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {CommonService} from "../service/common";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
declare var alertify:any;
declare var $:any;
@Component({
  templateUrl:'./noticeEdit.html'
})

export class NoticeEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private fileupload:FileUpload,
    private location:Location,
    private common:CommonService
  ){}


  private data:any={
    "endTime": "",
    "id":"",
    "startTime": "",
    "url": ""
  }

  private id:number = 0;
  private imagePath:string='';
  private isCreate:boolean=false;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });
    this.initTime();
    if(this.id!=0){
      this.getPath();
      this.getData(this.id);
    }else {
      this.isCreate=true;
    }
  }
  private initTime(){
    setTimeout(res=>{
      $("#startTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,
        startDate:this.common.dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss'),
      }).on('changeDate', function(ev){
        $("#endTime").datetimepicker('setStartDate',$("#startTime").val());
      });

      $("#endTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,
        startDate:this.common.dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss'),
      }).on('changeDate', function(ev){
        $("#startTime").datetimepicker('setEndDate',$("#endTime").val());
      });
    })

  }
  private getData(id:number):void{
    this.HttpService.getData(API.notice+"/"+id).then(res=>{
      this.data = res.data;
      if(typeof this.data.startTime=='object'){
        this.data.startTime='';
      }
      if(typeof this.data.endTime=='object'){
        this.data.endTime='';
      }
    })
  }

  // 获取路径
  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }

  private submit():void{
    this.HttpService.postData(API.notice,{
      'id':this.id,
      "endTime":$('#endTime').val(),
      "startTime":$('#startTime').val(),
      "url": this.data.url
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

  private showIconEn:boolean = false;

  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'url':self.showIconEn=true;break;

        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

  //删除时间值
  private removeStartTime(){
    $('#startTime').val('');
  }
  private removeEndTimeDetil(){
    $('#endTime').val('');
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/notice/noticeEdit.component.ts